import AssigneeChip from './AssigneeChip';

export default AssigneeChip;
